// Wraps a Today widget and overlays up/down reorder controls when the page
// is in customize mode. In normal mode it's a no-op pass-through (we keep
// the wrapper mounted to avoid remounting children when toggling customize).

import React from 'react'
import styled from 'styled-components'

const Slot = styled.div`
  position: relative;
  ${(p) =>
    p.$customizing &&
    `
    outline: 2px dashed ${p.theme?.color?.borderStrong || '#D5CCBC'};
    outline-offset: 4px;
    border-radius: 14px;
  `}
`

const ControlsBar = styled.div`
  position: absolute;
  top: -14px;
  right: 12px;
  display: flex;
  gap: 4px;
  z-index: 5;
  background: ${(p) => p.theme?.color?.bgRaised || '#fff'};
  border-radius: 999px;
  padding: 4px;
  box-shadow: ${(p) => p.theme?.shadow?.raised || '0 4px 16px rgba(31,41,55,0.12)'};
  border: 1px solid ${(p) => p.theme?.color?.border || '#E6E0D6'};
`

const ArrowButton = styled.button`
  appearance: none;
  border: none;
  background: ${(p) => p.theme?.color?.bgSubtle || '#F4F0E9'};
  width: 30px;
  height: 30px;
  border-radius: 50%;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: ${(p) => p.theme?.color?.ink || '#1F2937'};
  transition: background 150ms ease-out;
  &:hover:not(:disabled) {
    background: ${(p) => p.theme?.color?.primarySoft || '#E8EEF6'};
    color: ${(p) => p.theme?.color?.primary || '#1F3A5F'};
  }
  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`

export default function ReorderableSlot({
  cardKey,
  customizing,
  canMoveUp,
  canMoveDown,
  onMoveUp,
  onMoveDown,
  children,
}) {
  return (
    <Slot $customizing={customizing}>
      {customizing && (
        <ControlsBar role="group" aria-label={`Reorder ${cardKey} card`}>
          <ArrowButton
            type="button"
            aria-label={`Move ${cardKey} up`}
            disabled={!canMoveUp}
            onClick={() => onMoveUp(cardKey)}
          >
            ↑
          </ArrowButton>
          <ArrowButton
            type="button"
            aria-label={`Move ${cardKey} down`}
            disabled={!canMoveDown}
            onClick={() => onMoveDown(cardKey)}
          >
            ↓
          </ArrowButton>
        </ControlsBar>
      )}
      {children}
    </Slot>
  )
}
